<template>
    <vDealDetailListComponent v-if="flag" :postList="postList"></vDealDetailListComponent>
</template>
<script>
import vDealDetailListComponent from '../../listComponent/order/dealDetailListComponent.vue';
export default {
    name: 'tradeLineList',
    components: {
        vDealDetailListComponent
    },
    data() {
        return {
            flag: false,
            postList: {
                headerTitle: false,
                order_rid: true,
                deal_line_rid: true,
                order_name: true,
                product_rid: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            }
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>